import { useEffect, useState } from 'react';
import { Grid, Stack } from '@mui/material';

import TotalGrowthBarChart from '../TotalGrowthBarChart';
import { gridSpacing } from 'store/constant';
import StockCard from '../StockCard';
import TopPreorder from '../TopPreorder';
import TotalCardSummary from '../TotalCardSummary';
import TotalIncome from '../TotalIncome';
import StockCardCustomer from 'views/shopsCustomer/reportDashboardStockCustomer/StockCard';
import PopularCardCustomer from 'views/shopsCustomer/reportDashboardStockCustomer/PopularCard';
import TotalGrowthBarChartCustomer from 'views/shopsCustomer/reportDashboardStockCustomer/TotalGrowthBarChart';

const Dashboard = () => {
    const Roles = (localStorage.getItem('role') || '').split(',');
    const [, setLoading] = useState(true);
    useEffect(() => { setLoading(false); }, []);

    const isAdmin = Roles.includes('37');
    const isCustomerShop = Roles.includes('45');

    return (
        <Grid container spacing={gridSpacing}>
            {/* Admin role: 2-column layout — left (Stock side) / right (Income side) */}
            {isAdmin && (
                <>
                    <Grid item lg={6} md={6} sm={12} xs={12}>
                        <Stack spacing={gridSpacing}>
                            <TotalCardSummary />
                            <StockCard />
                        </Stack>
                    </Grid>
                    <Grid item lg={6} md={6} sm={12} xs={12}>
                        <Stack spacing={gridSpacing}>
                            <TotalIncome />
                            <TopPreorder />
                        </Stack>
                    </Grid>

                    <Grid item xs={12}>
                        <TotalGrowthBarChart />
                    </Grid>
                </>
            )}

            {/* Customer-shop role */}
            {isCustomerShop && (
                <>
                    <Grid item lg={6} md={6} sm={12} xs={12}>
                        <StockCardCustomer />
                    </Grid>
                    <Grid item lg={6} md={6} sm={12} xs={12}>
                        <PopularCardCustomer />
                    </Grid>
                    <Grid item xs={12}>
                        <TotalGrowthBarChartCustomer />
                    </Grid>
                </>
            )}
        </Grid>
    );
};

export default Dashboard;
